export default {
  'DISCLAIMER.title': '免责声明',
  'DISCLAIMER.content': `本会议记录稿中所包含的的信息、资料和内容仅供参考，不具有任何形式的商业建议，对投资决策不具有影响力。本
  会议记录为整理稿（即非逐字记录），为了便于阅读，高临咨询已对记录稿进行剪辑。高临管理咨询有限公司和其关
  联的公司（统称"高临咨询"）对此内容或任何错误、省略处及不准确方面，概不负责且不承担任何的法律责任。专家所
  发表的内容仅表明其个人的立场和观点，并不代表高临咨询的观点。对此记录稿内容的版权、知识产权和其他权利均
  属于高临咨询所有。未经允许严禁修改、编辑、复制、发表、传播、传递、出版、授权、模仿、转载或销售。`,
  'AGENDA.title': '议程',
  'CONTENTS.title': '目录',
  'CONTENTS.link_title': '转到相关部分',
  'READING_LIST_LINKS.title': '在同一主题上：',
};



// WEBPACK FOOTER //
// ./Intl/zh_cn.js